export enum AlertType {
	SUCCESS = 'Success',
	ERROR = 'Error'
}
